module.exports = __webpack_public_path__ + "static/media/b3.80167151.webp";